import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDestinationIcon = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M9 0C9.34173 0 9.62414 0.253938 9.66884 0.583406L9.675 0.675L9.67416 2.28394C12.8635 2.59882 15.4012 5.13647 15.7169 8.32728L15.75 8.325H17.325C17.6978 8.325 18 8.62721 18 9C18 9.34173 17.7461 9.62414 17.4166 9.66884L17.325 9.675L15.7155 9.67413C15.4012 12.8635 12.8635 15.4012 9.67272 15.7169L9.675 15.75V17.325C9.675 17.6978 9.37279 18 9 18C8.65827 18 8.37586 17.7461 8.33116 17.4166L8.325 17.325L8.32587 15.7155C5.13647 15.4012 2.59882 12.8635 2.2831 9.67272L2.25 9.675H0.675C0.302208 9.675 0 9.37279 0 9C0 8.65827 0.253938 8.37586 0.583406 8.33116L0.675 8.325L2.28394 8.32584C2.59882 5.13647 5.13647 2.59882 8.32728 2.2831L8.325 2.25V0.675C8.325 0.302208 8.62721 0 9 0ZM9 3.6C6.01766 3.6 3.6 6.01766 3.6 9C3.6 11.9823 6.01766 14.4 9 14.4C11.9823 14.4 14.4 11.9823 14.4 9C14.4 6.01766 11.9823 3.6 9 3.6ZM9 5.4C10.9882 5.4 12.6 7.01177 12.6 9C12.6 10.9882 10.9882 12.6 9 12.6C7.01177 12.6 5.4 10.9882 5.4 9C5.4 7.01177 7.01177 5.4 9 5.4Z",
		className: "icons-color"
	})]
});
const ForwardRef = forwardRef(SvgDestinationIcon);
export default ForwardRef;
